import { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { AppSettingsService } from "@/service/AppSettingsService";
import Logger from "@/utils/Logger";

const redirectUri = `${window.location.origin}${window.location.pathname}`;

export const createOidcConfig = (): AuthProviderProps => {
  const handleSigninCallback = () => {
    Logger.info("User signed in successfully", ["OidcConfig"]);
    window.history.replaceState({}, document.title, redirectUri);
  };

  const handleSignoutCallback = () => {
    Logger.info("User signed out successfully", ["OidcConfig"]);
  };

  const oidcConfig: AuthProviderProps = {
    authority: AppSettingsService.getOpenIdAuthority(),
    client_id: AppSettingsService.getPingClientId(),
    redirect_uri: redirectUri,
    post_logout_redirect_uri: `${window.location.origin}/`,
    response_type: "code",
    scope: "openid profile email",
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: `${window.location.origin}/auth/silent-callback`,
    monitorSession: true,
    includeIdTokenInSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    // Event callbacks for logging
    onSigninCallback: () => handleSigninCallback(),
    onSignoutCallback: () => handleSignoutCallback(),
  };

  // Logger.info("OIDC Configuration", [
  //   "OidcConfig",
  //   JSON.stringify(oidcConfig, null, 2),
  // ]);
  return oidcConfig;
};
